export const cookieConsent = {
  cookieConsentTitle: "Cookie 与隐私",
  cookieConsentMessage: "我们使用 Cookie 及类似技术以改善体验并统计网站使用情况。",
  cookieConsentAcceptBtn: "接受",
  cookieConsentRejectBtn: "拒绝",
};
